/* istanbul ignore file */
export * from './SearchAnimatedPlaceholder';
